var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.635 2.634c0-.209.08-.417.24-.576 0 0-.036.031.038-.036q.024-.023.06-.052a2 2 0 0 1 .193-.142c.162-.108.39-.237.7-.36C4.483 1.22 5.405 1 6.725 1c1.385 0 2.534.46 3.53.858l.046.019c1.038.415 1.922.76 2.97.76 1.134 0 1.848-.19 2.252-.351.203-.081.332-.157.4-.203l.06-.043a.818.818 0 0 1 1.378.596v9.818c0 .21-.08.42-.24.58q-.047.046-.098.087-.071.06-.192.142a4 4 0 0 1-.7.36c-.618.248-1.541.468-2.86.468-1.386 0-2.534-.46-3.532-.859l-.045-.018c-1.038-.415-1.921-.76-2.97-.76-1.134 0-1.848.19-2.252.351a3 3 0 0 0-.202.09v5.287a.818.818 0 1 1-1.636 0V2.634"
  })));
};
export default SvgFlag;